module.exports = __webpack_public_path__ + "img/recreation.3ce598d5.png";